import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function searchCommune(query, page = 1, start = 0, limit = 20, showCom = true) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.searchCommune,
    params: {
      query,
      page,
      start,
      limit,
      showCom
    }
  }).then(r => r.data);
}

function searchCodePostal(codepostal, showCom = true) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.searchCodepostal,
    params: {
      codepostal,
      showCom
    }
  }).then(r => r.data);
}

export default {
  searchCommune,
  searchCodePostal,
};



// WEBPACK FOOTER //
// ./src/repositories/commune.repository.js